

import * as envalid from 'envalid';
import * as path from 'path';
const { str } = envalid;

let sshPath: string;
let projectYamlPath: string;

// in development mode, we provide path for following file
// which exists in the servers/backend-server folder
if (process.env.NODE_ENV === 'development') {
    sshPath = path.resolve('./keys/ssh');
    console.log('---SSSH PATH', sshPath);
    projectYamlPath = path.resolve('./project.yaml');
}


export const config = envalid.cleanEnv(process.env, {
    NODE_ENV: str({ default: 'production', choices: ['production', 'staging', 'development', 'test'] }),
    WORKSPACE_PROJECT_FILE: str({default: '/etc/cdebase/project.yaml', devDefault: projectYamlPath}),
    GIT_SSH_KEY_LOCATION: str({default: '/etc/cdebase/gitsecret/ssh', devDefault: sshPath}),
});
